module.exports = __webpack_public_path__ + "static/media/4daa2125-53c6-4da8-9614-8a1049eaccc2.9cf24796.woff2";